export default function SummaryCard({ label, value }) {
  return (
    <article className="card metric">
      <span>{label}</span>
      <strong>{value}</strong>
    </article>
  );
}